import * as $ from 'jquery';
import { $id } from '../../../../services/jquery-utils';
import { isDesktop, isIOS } from '../../storage';
import { validateField } from '../../validation/validator';
import Unibar from '../unibar';
import { createUnibar, getUnibar } from './unibar-storage';

export default function loadUnibars(): void {

    const $unibars = $('.unibar');

    // Create unibars
    const fields: Unibar[] = [];
    $unibars.each((_, el) => {
        createUnibar(el);

        const field = getUnibar(el.id);
        field.onChangeAC(() => validateField(field));
        fields.push(field);
    });

    // Full screen on focus mobile
    if (!isDesktop && !isIOS) {
        enableFullscreen(fields);
    }

    handleChange();
}

/**
 * Full screen on focus
 */
function enableFullscreen(unibars: Unibar[]): void {
    let focusedParent: HTMLElement;
    const $backBtn = $id('back-btn-focused');

    const focus = (parent: HTMLElement) => {
        if (!parent.classList.contains('inputDiv')) {
            return;
        }

        parent.classList.add('focused');
        $backBtn.show();
        scrollTo(0, 0);
        focusedParent = parent;
    };

    const unfocus = () => {
        if (!focusedParent) return;
        focusedParent.classList.remove('focused');
        $backBtn.hide();
    };

    unibars.forEach(bar => {
        bar.$JQuery.focusin(function () {
            const parent = this.parentElement;
            if (parent) focus(parent);
        });

        bar.onSelect(() => unfocus());
    });

    $backBtn.click(unfocus);
}

function handleChange(): void {
    // Copy selected results to return
    const rules: Array<{
        from: Unibar | null,
        to: Unibar | null
    }> = [
            // Copy no flight to return
            {
                // From (no flight) -> To (no flight) return
                from: getUnibar('noflight-origin'),
                to: getUnibar('noflight-originReturn')
            }, {
                // To (no flight) -> From (no flight) return
                from: getUnibar('noflight-destination'),
                to: getUnibar('noflight-destinationReturn')
            },

            // Copy no flight to flight
            {
                // From (no flight) -> From (flight)
                from: getUnibar('noflight-origin'),
                to: getUnibar('fromHome')
            }, {
                // To (no flight) -> To (flight)
                from: getUnibar('noflight-destination'),
                to: getUnibar('toHotel')
            },

            // Copy flight to return
            {
                // From (flight) -> To (flight) return
                from: getUnibar('fromHome'),
                to: getUnibar('toHotelReturn')
            }, {
                // To (flight) -> From (flight) return
                from: getUnibar('toHotel'),
                to: getUnibar('fromHomeReturn')
            }];

    rules.forEach(r => {
        if (!r.from) return;

        r.from.onChangeAC((selected, prev) => {
            if (!r.to) return;

            // Check if result should be copied
            const targetResult = r.to.selectedResult;
            const targetEmpty = !targetResult && r.to.isEmpty(),
                targetSynced = !targetEmpty || prev && targetResult ;

            // Copy the selected result
            if (targetEmpty || targetSynced) {
                if (selected) {
                    r.to.setValue(selected);
                } else r.to.clear();
            }
        });
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/input-fields/unibar/unibar-loader.ts